// extracted by mini-css-extract-plugin
export default {"highlighted":"TEhYIl","empty":"nIHt5X","with-content":"bQok89","withContent":"bQok89"};